const { getElement } = window.BAO.Utils

class MarketSwitcherSelect extends window.BAO.CustomElement({
  SuperClass: HTMLSelectElement,
}) {
  connectedCallback () {
    super.connectedCallback()
    this.updateFlagImage(this.selectedOptions[0])
  }

  setupListeners () {
    this.handleChange = this.handleChange.bind(this)

    this.listeners.add(this, 'change', this.handleChange)
  }

  handleChange (event) {
    const selectedOption = event.target.options[event.target.selectedIndex]
    this.updateFlagImage(selectedOption)
  }

  updateFlagImage (selectedOption) {
    const selectedImage = selectedOption?.getAttribute('data-flag')
    const img = this.image

    if (!img || !selectedImage) return

    const countryCode = selectedOption?.value?.toLowerCase()
    let flagSrc = selectedImage

    if (flagSrc.startsWith('//')) {
      flagSrc = `https:${flagSrc}`
    }

    img.src = flagSrc
    img.srcset = ''
    img.removeAttribute('sizes')

    if (!countryCode) return

    img.onerror = () => {
      img.onerror = null
      img.src = `https://cdn.shopify.com/static/images/flags/${countryCode}.svg?width=60`
    }
  }

  get image () {
    if (!this.externalEls?.image?.exists) return null

    return getElement('img', { context: this.externalEls.image.element })
  }
}

if (!customElements.get('market-switcher-select')) {
  customElements.define('market-switcher-select', MarketSwitcherSelect, {
    extends: 'select',
  })
}
